import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { EndPoints } from 'src/app/shared/enums';

@Injectable({
  providedIn: 'root',
})
export class BadeLoftService {
  //#region stock page api calls
  GetStocks(
    searchText: any,
    sortField: string,
    sortBy: number,
    page: number,
    pageSize: number,
    isLoader: boolean,
    isArchivedStock: boolean
  ) {
    let queryParams = searchText
      ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&IsArchivedStock=${isArchivedStock}`
      : `?sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&IsArchivedStock=${isArchivedStock}`;
    return this._cS.API_GET(EndPoints.GetStocks + queryParams, isLoader);
  }

  CreateStock(body: any) {
    return this._cS.API_POST(EndPoints.CreateStock, body);
  }

  ImportStock(body: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ImportStock, body, true, {
      headers: hd,
    });
  }

  UpdateStock(body: any) {
    return this._cS.API_POST(EndPoints.UpdateStock, body);
  }

  DeleteStock(stockId: number) {
    return this._cS.API_DELETE(EndPoints.DeleteStock + `?stockId=${stockId}`);
  }

  DeleteStockPart(stockId: number, partNumber: number) {
    return this._cS.API_DELETE(
      EndPoints.DeleteStockPart + `?stockId=${stockId}&PartNumber=${partNumber}`
    );
  }

  UpdateStockLocation(stockId: string, location: number) {
    return this._cS.API_GET(
      EndPoints.UpdateStockLocation + `?stockId=${stockId}&location=${location}`
    );
  }

  ValidateStockName(stockName: string) {
    return this._cS.API_POST(
      EndPoints.ValidateStockName + `?stockName=${stockName}`,
      {},
      false
    );
  }
  SaveWarehouseStock(body: any) {
    return this._cS.API_POST(EndPoints.SaveWarehouseStock, body);
  }
  GetPartNumbers() {
    return this._cS.API_GET(EndPoints.GetPartNumbers);
  }

  GetAssignmentDetails(id: any, partNumber: any) {
    return this._cS.API_GET(
      EndPoints.GetAssignmentDetails +
      `?warehoueStockId=${id}&partNumber=${partNumber}`,
      false
    );
  }
  GetStockAssignmentDetailV1(id: any, partNumber: any) {
    return this._cS.API_GET(
      EndPoints.GetStockAssignmentDetailV1 +
      `?stockId=${id}` +
      `&partNumbers=${partNumber}`,
      false
    );
  }

  DownloadPhysicalInventoryTemplate() {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.DownloadPhysicalInventoryTemplate, hd);
  }

  UpdateStockAsArchive(stockId: string) {
    return this._cS.API_POST(
      EndPoints.UpdateStockAsArchive + `?stockId=${stockId}`
    );
  }

  GetAuditLog(entityId: string, entityType: number) {
    return this._cS.API_GET(
      EndPoints.GetAuditLog + `?EntityId=${entityId}&EntityType=${entityType}`
    );
  }

  TransferPartNumber(
    partNumber: string,
    fromStockId: string,
    toStockId: string,
    quantity: number,
    assignmentId: string
  ) {
    return this._cS.API_POST(
      EndPoints.TransferPartNumber +
      `?partNumber=${partNumber}&fromStockId=${fromStockId}&toStockId=${toStockId}&Quantity=${quantity}&assignmentId=${assignmentId}`
    );
  }

  GetPartNumberDetail(stockId: string) {
    return this._cS.API_GET(
      EndPoints.GetPartNumberDetail + `?stockId=${stockId}`,
      false
    );
  }
  //#endregion

  //#region assignmnet api calls
  GetCustomerDropdown() {
    return this._cS.API_GET(EndPoints.GetCustomerDropdown, false);
  }

  GetCustomerInvoiceDropdown(customerId: string) {
    return this._cS.API_GET(
      EndPoints.GetCustomerInvoiceDropdown + `?customerId=${customerId}`
    );
  }

  GetStockDropdown(stockId?: string) {
    let queryParams = stockId ? `?stockId=${stockId}` : '';
    return this._cS.API_GET(EndPoints.GetStockDropdown + queryParams);
  }

  GetStockDropdownWithQty(partNumber: string) {
    let queryParams = `?partNumber=${partNumber}`;
    return this._cS.API_GET(
      EndPoints.GetStockDropdownWithQty + queryParams,
      false
    );
  }

  GetStockPartDropdown(stockId: string) {
    return this._cS.API_GET(
      EndPoints.GetStockPartDropdown + `?stockId=${stockId}`
    );
  }

  GetAssignments(
    searchText: any,
    sortField: string,
    sortBy: number,
    page: number,
    pageSize: number,
    isLoader: boolean
  ) {
    let queryParams = searchText
      ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}`
      : `?sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}`;
    return this._cS.API_GET(EndPoints.GetAssignments + queryParams, isLoader);
  }

  CreateAssignment(body: any) {
    return this._cS.API_POST(EndPoints.CreateAssignment, body);
  }

  GetLatestCreatedInvocies() {
    return this._cS.API_GET(EndPoints.GetLatestCreatedInvoices, false);
  }

  GetLastMonthUnAssignInvoices() {
    return this._cS.API_GET(EndPoints.GetLastMonthUnAssignInvoices, false);
  }

  DeleteAssignment(assignmentId: string) {
    return this._cS.API_DELETE(
      EndPoints.DeleteAssignment + `?assignmentId=${assignmentId}`
    );
  }

  DeleteAssignmentStock(assignmentId: string, stockId: string) {
    return this._cS.API_DELETE(
      EndPoints.DeleteAssignmentStock +
      `?assignmentId=${assignmentId}&stockId=${stockId}`
    );
  }
  DeleteAssignmentPartNumber(
    assignmentId: string,
    stockId: string,
    partNumber: string
  ) {
    return this._cS.API_DELETE(
      EndPoints.DeleteAssignmentPartNumber +
      `?assignmentId=${assignmentId}&stockId=${stockId}&partNumber=${partNumber}`
    );
  }

  AddAssignmentStock(body: any) {
    return this._cS.API_POST(EndPoints.AddAssignmentStock, body);
  }

  GetInvoiceByNumber(invoiceNumber: any) {
    return this._cS.API_GET(
      EndPoints.GetInvoiceByNumber + `?invoiceNumber=${invoiceNumber}`
    );
  }

  GetAssignmentDetailsById(assignmentId: string) {
    return this._cS.API_GET(
      EndPoints.GetAssignmentDetailsById + `?assignmentId=${assignmentId}`
    );
  }

  SaveAssignmentNotes(id: string, notes: string) {
    return this._cS.API_GET(
      EndPoints.SaveAssignmentNotes + `?id=${id}&notes=${notes}`,
      false
    );
  }

  SyncLatestCustomers() {
    return this._cS.API_GET(EndPoints.SyncLatestCustomers, false);
  }

  SyncLatestInvoices(customerId: string) {
    return this._cS.API_GET(
      EndPoints.SyncLatestInvoices + `?customerId=${customerId}`,
      false
    );
  }

  ValidateAssignmentStock(body: any) {
    return this._cS.API_POST(EndPoints.ValidateAssignmentStock, body, true);
  }

  ExpandAllPartnumber(body: any) {
    return this._cS.API_POST(EndPoints.ExpandAllPartnumber, body);
  }

  //#endregion

  //#region status api calls
  GetStatusV1(
    searchText: any,
    sortField: string,
    sortBy: number,
    page: number,
    pageSize: number,
    fromDate: string,
    toDate: string,
    isLoader: boolean
  ) {
    let queryParams = searchText
      ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&FromDate=${fromDate}&Todate=${toDate}`
      : `?sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&FromDate=${fromDate}&Todate=${toDate}`;
    return this._cS.API_GET(EndPoints.GetStatusV1 + queryParams, isLoader);
  }
  GetIntegrationStatus(
    searchText: any,
    sortField: string,
    sortBy: number,
    page: number,
    pageSize: number,
    fromDate: string,
    toDate: string,
    protectionRoute: string,
    isLoader: boolean
  ) {
    let queryParams = searchText
      ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&FromDate=${fromDate}&Todate=${toDate}&filterProtection=${protectionRoute}`
      : `?sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&FromDate=${fromDate}&Todate=${toDate}&filterProtection=${protectionRoute}`;
    return this._cS.API_GET(
      EndPoints.GetRouteIntegrationStatus + queryParams,
      isLoader
    );
  }
  //#region sync dashboard api calls (Phase 22)
  GetSyncConnectorHealth(isLoader: boolean) {
    return this._cS.API_GET(EndPoints.GetSyncConnectorHealth, isLoader);
  }
  // KEYSET, not page numbers. beforeTimestamp/beforeSourceId are the last row already rendered; the
  // server returns the rows immediately after it, reading exactly pageSize per source at any depth.
  // Page-based reads re-read every preceding page -- measured on staging at pageSize=25: page 1 = 9.3s,
  // page 6 = 29.6s. Empty cursor = first page (the server falls back to its page-1 offset read).
  GetSyncActivity(
    connector: string,
    status: string,
    fromDate: string,
    toDate: string,
    pageSize: number,
    beforeTimestamp: string,
    beforeSourceId: string,
    isLoader: boolean
  ) {
    let queryParams = `?connector=${connector}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&pageSize=${pageSize}`;
    if (beforeTimestamp && beforeSourceId) {
      queryParams += `&beforeTimestamp=${encodeURIComponent(beforeTimestamp)}&beforeSourceId=${encodeURIComponent(beforeSourceId)}`;
    }
    return this._cS.API_GET(EndPoints.GetSyncActivity + queryParams, isLoader);
  }
  // One row's payload, fetched when that row is expanded. It is deliberately NOT part of the
  // GetSyncActivity response any more -- at ~19.6 KB/row it was ~95% of the body for a panel that
  // starts collapsed. source/sourceId come straight off the row (encoded: sourceId is an ObjectId
  // and source a fixed collection name, but neither is built here so both are escaped on principle).
  GetSyncActivityDetail(source: string, sourceId: string, isLoader: boolean) {
    let queryParams = `?source=${encodeURIComponent(source)}&sourceId=${encodeURIComponent(sourceId)}`;
    return this._cS.API_GET(EndPoints.GetSyncActivityDetail + queryParams, isLoader);
  }
  //#region status api calls for incompleted status
  getIncompletedStatus(
    searchText: any,
    sortField: string,
    sortBy: number,
    page: number,
    pageSize: number,
    fromDate: string,
    toDate: string,
    isLoader: boolean
  ) {
    let queryParams = searchText
      ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&FromDate=${fromDate}&Todate=${toDate}`
      : `?sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&FromDate=${fromDate}&Todate=${toDate}`;
    return this._cS.API_GET(
      EndPoints.GetUncompletedStatus + queryParams,
      isLoader
    );
  }

  getIncompletedStatusCount() {
    return this._cS.API_GET(EndPoints.GetUncompletedStatusCount, false);
  }

  // GetStatusV1(
  //   searchText: any,
  //   sortField: string,
  //   sortBy: number,
  //   page: number,
  //   pageSize: number,
  //   fromDate : string,
  //   toDate : string,
  //   isLoader: boolean
  // ) {
  //   let queryParams = searchText
  //     ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&FromDate=${fromDate}&Todate=${toDate}`
  //     : `?sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}&FromDate=${fromDate}&Todate=${toDate}`;
  //   return this._cS.API_GET(EndPoints.GetStatus + queryParams, isLoader);
  // }

  UpdateCalledStatus(assignmentId: string, isCalled: boolean) {
    return this._cS.API_GET(
      EndPoints.UpdateCalledStatus +
      `?assignmentId=${assignmentId}&isCalled=${isCalled}`,
      false
    );
  }

  UpdateShippedDateAndStatus(body: any) {
    return this._cS.API_POST(EndPoints.UpdateShippedDateAndStatus, body);
  }
  //#endregion

  //#region dashboard api calls
  DashboardData(
    searchText: any,
    sortField: string,
    sortBy: number,
    page: number,
    pageSize: number,
    isLoader: boolean
  ) {
    let queryParams = searchText
      ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}`
      : `?sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}`;
    return this._cS.API_GET(EndPoints.DashboardData + queryParams, isLoader);
  }

  GetPartNumberAssignmentDetail(partNumber: string, stockId?: string) {
    var queryParam = stockId
      ? `?partNumber=${partNumber}&stockId=${stockId}`
      : `?partNumber=${partNumber}`;
    return this._cS.API_GET(
      EndPoints.GetPartNumberAssignmentDetail + queryParam,
      false
    );
  }
  GetN2OPartNumberAssignmentDetail(partNumber: string, stockId?: string) {
    var queryParam = `?partNumber=${partNumber}`;
    return this._cS.API_GET(
      EndPoints.GetN2OPartNumberAssignmentDetail + queryParam,
      false
    );
  }

  //#endregion

  ImportPhysicalInventoryFile(file: any) {
    return this._cS.API_POST(EndPoints.ImportPhysicalInventoryFile, file);
  }
  ConvertWayfairCSVFile(file: any) {
    return this._cS.API_POST(EndPoints.ConvertWayfairCSVFile, file);
  }

  getWarehouseList(
    searchText: any,
    sortField: string,
    sortBy: number,
    page: number,
    pageSize: number,
    isLoader: boolean
  ) {
    let queryParams = searchText
      ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}`
      : `?sortField=${sortField}&sortBy=${sortBy}&page=${page}&pageSize=${pageSize}`;
    return this._cS.API_GET(
      EndPoints.GetWareHouseStocks + queryParams,
      isLoader
    );
  }

  getUniqueAssignedList(assignedData: any) {
    const result = [];
    if (assignedData.assignmentList) {
      const map = new Map();
      for (const item of assignedData.assignmentList) {
        if (!map.has(item.customerId)) {
          map.set(item.customerId, true); // set any value to Map
          result.push({
            customerId: item.customerId,
            customerName: item.customerName,
            assignedQuantity: item.assignedQuantity,
            assignmentId: item.assignmentId,
            invoiceNo: item.invoiceNo,
            transactionID: item.transactionID,
            qB_PaymentStatus: item.qB_PaymentStatus,
          });
        }
      }
    }
    return result;
  }

  GetAssignmentStock(id: any) {
    return this._cS.API_GET(
      EndPoints.GetAssignmentStock + `?assignmentId=${id}`,
      false
    );
  }
  GetEditAssignmentStocksDetail(id: any) {
    return this._cS.API_GET(
      EndPoints.GetEditAssignmentStocksDetail + `?assignmentId=${id}`,
      false
    );
  }
  //UpdateShippedStatus(assignmentId: any, isRouteProtection: any) {
  UpdateShippedStatus(assignmentId: any) {
    return this._cS.API_POST(
      EndPoints.UpdateShippedStatus +
      //`?assignmentId=${assignmentId}&isRouteProtection=${isRouteProtection}`
      `?assignmentId=${assignmentId}`
    );
  }
  UpdatePartNumber(partBody: any) {
    return this._cS.API_POST(EndPoints.UpdatePartNumber, partBody);
  }

  GetStockAssignmentDetail(stockId: any) {
    return this._cS.API_GET(
      EndPoints.GetStockAssignmentDetail + `?stockId=${stockId}`,
      false
    );
  }
  GetN2OStockAssignmentDetail(sortBy: any) {
    return this._cS.API_GET(
      EndPoints.GetN2OStockAssignmentDetail + `?sortBy=${sortBy}`,
      false
    );
  }
  UpdateN2OAssignnmentStocksDetail(
    assignmentId: any,
    partNumber: any,
    isN2OChecked: any,
    piNumber: any
  ) {
    return this._cS.API_PUT(
      EndPoints.UpdateN2OAssignnmentStocksDetail +
      `?assignmentId=${assignmentId}&partNumber=${partNumber}&isN2OChecked=${isN2OChecked}&piNUmber=${piNumber}`,
      false
    );
  }

  GetAssignmentByInvoiceNumber(invoiceNo: any) {
    return this._cS.API_GET(
      EndPoints.GetAssignmentByInvoiceNumber + `?InvoiceNumber=${invoiceNo}`
    );
  }

  //route enhancement
  QBOCallBack(code: any, state: any, realmId: any) {
    return this._cS.API_GET(
      EndPoints.QBOCallBack + `?code=${code}&state=${state}&realmId=${realmId}`,
      true
    );
  }
  GetQBOAuthDetail() {
    return this._cS.API_GET(EndPoints.GetQBOAuthDetail, false);
  }
  QBOAuthConnectionTest() {
    return this._cS.API_GET(EndPoints.QBOAuthConnectionTest, false);
  }
  revokeQBOAuthConnectionTest() {
    return this._cS.API_GET(EndPoints.RevokeQBOAuthDetail, false);
  }
  ShopifyCallBack(queryString: string) {
    // Forward Shopify's full, unmodified callback query string (code, state, shop, hmac,
    // timestamp, host, ...) so the backend can validate the HMAC over the exact set of
    // params Shopify signed. Dropping any param (notably hmac) makes ValidateHmac fail → 400.
    return this._cS.API_GET(EndPoints.ShopifyCallBack + queryString, true);
  }
  GetShopifyAuthDetail() {
    return this._cS.API_GET(EndPoints.GetShopifyAuthDetail, false);
  }
  ShopifyAuthConnectionTest() {
    return this._cS.API_GET(EndPoints.ShopifyAuthConnectionTest, false);
  }
  revokeShopifyAuth() {
    return this._cS.API_GET(EndPoints.RevokeShopifyAuthDetail, false);
  }
  GetShopifyConnectionConfig() {
    return this._cS.API_GET(EndPoints.GetShopifyConnectionConfig, false);
  }
  registerShopifyWebhooks() {
    return this._cS.API_POST(EndPoints.ShopifyRegisterWebhooks, {}, true);
  }
  deregisterShopifyWebhooks() {
    return this._cS.API_POST(EndPoints.ShopifyDeregisterWebhooks, {}, true);
  }
  getShopifyWebhooks() {
    return this._cS.API_GET(EndPoints.ShopifyGetWebhooks, false);
  }
  syncRetailPrices() {
    return this._cS.API_POST(EndPoints.SyncRetailPrices, {}, true);
  }
  checkServiceStatus(serviceType: any) {
    return this._cS.API_GET(
      EndPoints.CheckServiceStatus + `?serviceType=${serviceType}`,
      false
    );
  }
  startWindowService() {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.StartWindowService, {}, false, {
      headers: hd,
      responseType: 'text',
    });
  }
  getInvoiceAmount(transactionId: any) {
    return this._cS.API_GET(
      EndPoints.GetInvoiceAmount + `?transactionId=${transactionId}`,
      false
    );
  }

  //get qbo orders
  getOrdersQBO(invoiceNumber: any, fromDate: string, toDate: string) {
    let queryParams = `?fromDate=${fromDate}&toDate=${toDate}&invoiceNumber=${invoiceNumber}`;

    return this._cS.API_GET(EndPoints.GetOrdersQBO + queryParams, false);
  }
  //get woocommerce orders (server-side paged, searched, sorted)
  getOrdersWoocommerce(
    orderStatus: any,
    fromDate: string,
    toDate: string,
    page: number,
    pageSize: number,
    search: string,
    sortBy: string,
    sortDir: string
  ) {
    const queryParams =
      `?fromDate=${fromDate}&toDate=${toDate}&orderStatus=${orderStatus}` +
      `&search=${encodeURIComponent(search || '')}&sortBy=${sortBy}&sortDir=${sortDir}` +
      `&page=${page}&pageSize=${pageSize}`;
    return this._cS.API_GET(EndPoints.GetOrdersWoocommerce + queryParams, false);
  }
  getOrdersWayfair(fromDate: string) {
    let queryParams = `?fromDate=${fromDate}`;
    return this._cS.API_GET(EndPoints.GetOrdersWayfair + queryParams, false);
  }
  getOrdersShopify(fromDate: string, toDate: string) {
    let queryParams = `?fromDate=${fromDate}&toDate=${toDate}`;
    return this._cS.API_GET(EndPoints.GetOrdersShopify + queryParams, false);
  }

  // Manual "Sync" button on the Shopify orders listing. The API takes ONLY the order id and
  // re-derives everything server-side from the live Shopify order, so nothing about the row is sent.
  manualSyncShopifyOrder(shopifyOrderId: string) {
    return this._cS.API_POST(
      EndPoints.ManualSyncShopifyOrder + `/${shopifyOrderId}`,
      {}
    );
  }

  // Manual "Sync" button on the QBO orders listing — the reverse direction: create the Shopify
  // order a QBO invoice never got. Sends ONLY the invoice id; every rule is re-checked server-side
  // from the live QuickBooks invoice, so the row's own fields are deliberately not sent.
  manualSyncQBOInvoice(invoiceId: string) {
    return this._cS.API_POST(
      EndPoints.ManualSyncQBOInvoice + `/${invoiceId}`,
      {}
    );
  }

  // "Sync from AfterShip" modal (Status / Shipped pages). The server decides which status is allowed;
  // the modal only offers what this returns.
  getAfterShipStatus(assignmentId: string) {
    return this._cS.API_GET(
      EndPoints.GetAfterShipStatus + `?assignmentId=${encodeURIComponent(assignmentId)}`,
      false
    );
  }

  afterShipManualSync(body: { assignmentId: string; status: string }) {
    return this._cS.API_POST(EndPoints.AfterShipManualSync, body, false);
  }

  deleteQuickBookInvoice(invoiceNo: any) {
    return this._cS.API_POST(
      EndPoints.DeleteQuickBookInvoice + `?invoiceNo=${invoiceNo}`,
      {}
    );
  }
  updateWoocommerceOrderStatus(
    OrderId: any,
    isForCompleted: any,
    isForCancelled: any
  ) {
    return this._cS.API_PUT(
      EndPoints.UpdateWoocommerceOrderStatus +
      `?OrderId=${OrderId}&isForCompleted=${isForCompleted}&isForCancelled=${isForCancelled}`,
      {}
    );
  }

  //parts import
  importPart(body: any) {
    let hd = this._cS.GetAuthorizationHeader();
    return this._cS.API_POST(EndPoints.ImportPart, body, true, {
      headers: hd,
    });
  }
  //parts import
  QBOWebhookCallBack(body: any) {
    return this._cS.API_POST(EndPoints.QBOWebhookCallBack, body, true);
  }


  //#region Shipped

  //Get Shipped Data
  GetShippedData(
    searchText: any,
    sortField: string,
    sortBy: number,
    fromDate: string,
    toDate: string,
  ) {
    let queryParams = searchText
      ? `?searchText=${searchText}&sortField=${sortField}&sortBy=${sortBy}&FromDate=${fromDate}&Todate=${toDate}`
      : `?sortField=${sortField}&sortBy=${sortBy}&FromDate=${fromDate}&Todate=${toDate}`;
    return this._cS.API_GET(EndPoints.GetShippedData + queryParams);
  }

  //Update Shipped Return Status
  UpdateShippedReturnStatus(returnAssignment: any, status: boolean) {
    const queryParam = `?status=${status}`;
    return this._cS.API_PUT(
      EndPoints.UpdateShippedReturnStatus + queryParam, returnAssignment
    );
  }

  GetReturnAssignmentsData( sortField: string, sortBy: number,) {
    let queryParams = `?sortField=${sortField}&sortBy=${sortBy}`;
    return this._cS.API_GET(EndPoints.GetReturnAssignmentsData + queryParams);
  }

  UpdateReturnTrackingNumber(assignmentId: string, returnTrackingNumber: string) {
    let queryParam = `?returnAssignmentId=${assignmentId}&returnTrackingNumber=${returnTrackingNumber}`;
    return this._cS.API_PUT(
      EndPoints.UpdateReturnTrackingNumber + queryParam, {}
    );
  }

  UpdateDamagedAndB2SStatus(data: any, IsBackToStock: boolean = false, IsDamaged: boolean = false) {
    let queryParam = `?IsBackToStock=${IsBackToStock}&IsDamaged=${IsDamaged}`;
    return this._cS.API_PUT(
      EndPoints.UpdateDamagedAndB2SStatus + queryParam, data
    );
  }

  //#endregion Shipped

  constructor(private _cS: CommonService) { }
}
